// Shared Lenis instance + helper so nav links / buttons scroll correctly
// (native scrollIntoView fights Lenis's RAF loop).
let lenisInstance = null;

export const setLenis = (l) => {
  lenisInstance = l;
};

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisInstance) {
    lenisInstance.scrollTo(el, { offset: -70, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
